import { render, staticRenderFns } from "./CreatePublic.vue?vue&type=template&id=c43a4f4c&"
import script from "./CreatePublic.vue?vue&type=script&lang=js&"
export * from "./CreatePublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/damiryusipov/devProjects/jsProjects/freelance/msp_chat/client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCombobox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCombobox,VContainer,VFlex,VLayout,VTextField})
